import styled from "@emotion/styled";

import { Div } from "./layout";

export const ProgressWrapper = styled.div`
  label: progress-wrapper;
  width: 75%;
  height: 8px;
  background-color: ${({ theme }) => theme.custom.grayInputs};
  border-radius: 4px;
  overflow: hidden;
`;

export const ProgressInner = styled.div`
  height: 100%;
  width: ${({ progress }) => `${progress}%`};
  background-color: ${({ theme }) => theme.palette.primary.main};
  transition: width 0.3s ease;
`;

export const DivButtons = styled(Div)`
  flex-wrap: ${(props) => props.wrap || "nowrap"};
`;


